<template>
  <highcharts class="chart" :options="options" ref="highchart" />
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil, isEqual, isEmpty, cloneDeep, map } from 'lodash';
import moment from 'moment';
import { stackedColumnOptions } from '@/constants/chart-options';
import AmsResultAPI from '@/api/ams/result';

export default {
  name: 'WStackedColumnChart',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    filterList: {
      type: Array,
      default: () => [],
    },
    searchParams: {
      type: Array,
      default: null,
    },
  },
  computed: mapGetters(['analysisDateParams']),
  data() {
    return {
      options: cloneDeep(stackedColumnOptions),
    };
  },
  watch: {
    active: {
      handler(value) {
        if (!isNil(value) && value) {
          if (isEmpty(this.filterList)) {
            this.loadData();
          }
        }
      },
      immediate: true,
    },
    analysisDateParams() {
      this.setChartOption();
      this.loadData();
    },
    filterList() {
      this.loadData();
    },
    searchParams() {
      this.loadData();
    },
  },
  mounted() {
    this.setChartOption();
  },
  methods: {
    loadData() {
      if (!this.active) {
        return;
      }
      const resultStatusList = [
        {
          name: '성공',
          resultStatus: '성공',
          color: 'rgb(86, 139, 210)',
        },
        {
          name: '실패',
          resultStatus: '실패',
          color: 'rgb(253, 116, 132)',
        },
        {
          name: '부분성공',
          resultStatus: '부분성공',
          color: 'rgb(247, 186, 0)',
        },
        // {
        //   name: '진행중',
        //   resultStatus: '진행중',
        //   color: 'rgb(209, 209, 209)',
        // },
      ];
      const resultStatusFilters = this.filterList.filter((item) => isEqual(item.type, 'resultStatus'));
      const triggerFilters = this.filterList.filter((item) => isEqual(item.type, 'triggerList'));
      const params = {
        startDatetime: this.analysisDateParams.startDatetime,
        endDatetime: this.analysisDateParams.endDatetime,
        resultStatusList,
        resultStatusFilters: map(resultStatusFilters, 'label'),
        triggerFilters: map(triggerFilters, 'triggerId'),
        searchParams: this.searchParams,
      };
      AmsResultAPI.getTriggerExectionResultStackedColumnChartData(params).then((response) => {
        this.options.series = response.data.data;
      });
    },
    setChartOption() {
      const startDatetime = moment(this.analysisDateParams.startDatetime);
      const endDatetime = moment(this.analysisDateParams.endDatetime);
      const diff = endDatetime.diff(startDatetime, 'hours');
      let labelFormat = '{value: %Y-%m-%d}';
      let interval = null;
      let tooltipFormat = '%Y-%m-%d';
      if (diff < 1) {
        labelFormat = '{value: %H:%M}';
        tooltipFormat += ' %H:%M';
      } else if (diff > 0 && diff <= 24) {
        labelFormat = '{value: %H시}';
        interval = 3600 * 1000;
        tooltipFormat += ' %H시';
      }
      this.options.xAxis.tickInterval = interval;
      Object.assign(this.options.xAxis.labels, { format: labelFormat });

      this.options.tooltip.xDateFormat = tooltipFormat;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/work/popup/components/ExecutionResult/components/StackedColumnChart.vue